import { AnimatedLoader } from '@/components/ui/animated-loader'
import { FadeIn, ScaleIn } from '@/components/motion'

interface CompleteStepProps {
  selectedRole: 'genius' | 'client' | null
}

export function CompleteStep({ selectedRole }: CompleteStepProps) {
  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <ScaleIn className="text-center">
        <AnimatedLoader message="Setting up your account..." />
        <FadeIn delay={0.3}>
          <p className="text-slate-400 mt-4">
            Redirecting to your {selectedRole === 'client' ? 'client' : 'expert'} dashboard...
          </p>
        </FadeIn>
      </ScaleIn>
    </div>
  )
}
